
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connectivity-issues/diagnose",
      function () {
        return require("private-next-pages/connectivity-issues/diagnose.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connectivity-issues/diagnose"])
      });
    }
  